import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DataProvider } from '../data/data';
import { Storage } from '@ionic/storage';
import { Events} from 'ionic-angular';
import { map } from 'rxjs/operators';
import { first } from 'rxjs/operators';
import * as moment from 'moment';
import { AngularFirestore, AngularFirestoreCollection,AngularFirestoreDocument } from '@angular/fire/firestore';
/*
  Generated class for the LogProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class LogProvider {
  
  email:string;
  uid:string;
  constructor(public http: HttpClient, public events:Events,public data:DataProvider,private afs: AngularFirestore,private storage: Storage) {
    console.log('Hello LogProvider Provider');
  }


   intializeSubscriptions(){

   		  this.setUidEmail();

   		  this.events.subscribe('log:add', (message, type, data) => {

       			this.addLog(message,type, data);

     	 });

      // this.completeSections();

      //this.updateAuditTimeline();
   }

   async setUidEmail(){
   	      this.uid = await this.storage.get('uid');
          this.email = await this.storage.get('email');
   }


   async addLog(message,type, data){

   		if(!this.email){
   			this.email = await this.storage.get('email');
   		}
   		if(!this.uid){
   			this.uid = await this.storage.get('uid');
   		}

   		if(data && data.email){
   			this.email = data.email;
   		}

   		let log = {
   			email:this.email,
   			uid:this.uid,
   			type:type,
   			val:message,
   			created:new Date()
   		}

   		

   		console.log("adding log");
   		console.log(log);

   		if((log['uid'] || log['email']) && log['val']){
   			if(!log['uid']){
   				delete log['uid'];
   			}
   			if(!log['email']){
   				delete log['email'];
   			}
   			if(!log['type']){
   				delete log['type'];
   			}
   			await this.afs.collection('logs').add(log);
   	    }
   }

   async completeSections(){

     let auditId = "GPGTiySjFHPueoTUkGKs";
     let auditTypeId = "tNsQALgWj95x9axkdiBd";
     let sectionId1 = "tBuvJqluT5F4EH8mDEvB";
     let sectionId2 = "uSlaWwXok7Fitd119GsL";
     let sectionId3 = "1RAzScKldEJ01V3RdnxH";
     let sectionId4 = "zimisI3U3MpjIW9Xf1sK";


 let currentSectionId = sectionId4;
    let data:any = [
{"e":"Ok","n":""},
{"e":"","n":""},
{"e":"NG","n":"No damage but there are few small pieces of waste in the driveway."},
{"e":"","n":"There is a pile of garbage near the service entrance"},
{"e":"","n":""},
{"e":"Ok","n":""},
{"e":"Ok","n":""},
{"e":"","n":""},
{"e":"NG","n":"There is wall paint damage."},
{"e":"","n":""},
{"e":"","n":""},
{"e":"","n":""},
{"e":"","n":""},
{"e":"Ok","n":""},
{"e":"","n":""},
{"e":"NG","n":"Not available."},
{"e":"NG","n":"Not available"},
{"e":"Ok","n":""},
{"e":"","n":""},
{"e":"OK","n":""},
{"e":"","n":""},
{"e":"","n":""},
{"e":"","n":""},
{"e":"","n":""},
{"e":"Ok","n":""},
{"e":"","n":""},
{"e":"Ok","n":"Lounge is common for sales and service."},
{"e":"Ok","n":""},
{"e":"Ok","n":""},
{"e":"Ok","n":""},
{"e":"","n":""},
{"e":"NG","n":"Restroom is common for sales and service"},
{"e":"Ok","n":""},
{"e":"Ok","n":""},
{"e":"Ok","n":"Combined with retail parts counter"},
{"e":"","n":""},
{"e":"","n":""},
{"e":"","n":""},
{"e":"Ok","n":""},
{"e":"Ok","n":""},
{"e":"","n":"There is a system in place but it is not efficient. Better use a logsheet instead of form."},
{"e":"Ok","n":""},
{"e":"Ok","n":""},
{"e":"Ok","n":"Mobile tools compartment does not contain unnecessary or personal items."},
{"e":"","n":""},
{"e":"NG","n":"Area is generally clean but floor paint is flaking."},
{"e":"Ok","n":""},
{"e":"Ok","n":""},
{"e":"NG","n":"Car wash area is generally clean but there is paint damage and oil stains on the wall."},
{"e":"Ok","n":"No unnecessary items on workbay area. Area is generally clean."},
{"e":"Ok","n":""},
{"e":"Ok","n":""},
{"e":"NG","n":"Water leakage affects the workshop wall."},
{"e":"","n":""},
{"e":"","n":""},
{"e":"NG","n":"Some lights are busted in the workshop area."},
{"e":"","n":""},
{"e":"NG","n":""},
{"e":"","n":"Some parts are stored in the workshop area. Some parts in the warehouse are not in the shelf."},
{"e":"Ok","n":""},
{"e":"Ok","n":""},
{"e":"NG","n":""},
{"e":"","n":""},
{"e":"","n":"No helmet"},
{"e":"Ok","n":""},
{"e":"Ok","n":""},
{"e":"Ok","n":""},
{"e":"","n":""}
]
         let currentIndex, finalJSON:any = [];
         console.log("printing json");
         data.forEach((item) => {
         if(item['e'] && item['e'] != ''){
            finalJSON.push(item);
            currentIndex = finalJSON.length - 1;
         }
         else{
          if(item['n'] && item['n'] != ''){
           finalJSON[currentIndex]['n'] = finalJSON[currentIndex]['n'] +'\n'+item['n'];
          }
         }
          console.log(item)
         });

         console.log("final array");
         console.log(finalJSON);

          const typeSectionQues = await this.afs.collection('audtypes').doc(auditTypeId).collection('sections').doc(currentSectionId).collection('questions',ref => ref.orderBy('order').where('active', '==', true)).snapshotChanges().pipe(
                  map(actions => actions.map(a => {
                    const data = a.payload.doc.data() as any;
                    const id = a.payload.doc.id;
                    return { id, ...data };
          }))).pipe(first()).toPromise();

         console.log("Type questions");
         console.log(typeSectionQues);

          typeSectionQues.forEach( async (que,index) => {
               if(finalJSON[index]['e'] && finalJSON[index]['e'].toUpperCase() == 'OK'){
               this.events.publish('audit:updateQueStatus',{auditId:auditId,sectionId:currentSectionId,queId:que.id, status:'pass'});
              }
              else{
                 this.events.publish('audit:updateQueStatus',{auditId:auditId,sectionId:currentSectionId,queId:que.id, status:'fail'});
              }

              if(finalJSON[index]['n'] != ''){
                await this.afs.collection('audits').doc(auditId).collection('sections').doc(currentSectionId).collection('questions').doc(que.id).update({comment:finalJSON[index]['n']});
              }

              console.log("updated que no.:"+index);
          });

          console.log("update completed");

  }

 async  updateAuditTimeline(){
    console.log("updating timeline");
    let auditId = 'SivJsoCs0zmMX2SuUtr2';



     const auditTimeline = await this.afs.collection('audits').doc(auditId).collection('timeline',ref => ref.orderBy('creationDate','desc')).snapshotChanges().pipe(
                  map(actions => actions.map(a => {
                    const data = a.payload.doc.data() as any;
                    const id = a.payload.doc.id;
                    if(data.creationDate){
                      data.creationDate = data.creationDate.toDate();
                    }
                    return { id, ...data };
    }))).pipe(first()).toPromise();

    auditTimeline.forEach(async(item) => {
      if(item.key == 'view_report'){
        await this.afs.collection('audits').doc(auditId).collection('timeline').doc(item.id).update({
          btn_text:'View Action Report',
          message:'Action Report Generated',
          key:'view_action_report'
        })
      }

    });

    auditTimeline.forEach(async(item) => {
     
      if(item.key == 'audit_finished'){

        let newDate = moment(item.creationDate).add(1,'ms');
         await this.afs.collection('audits').doc(auditId).collection('timeline').add({
              type:"action",
              message:"Audit report generated.",
              btn_text:"View Audit Report",
              key:'view_report',
              user:{
                id:item.user.id,
                name:item.user.name
              },
              active:true,
              creationDate:newDate.toDate()
            });
      }

    });

  }

}



// WEBPACK FOOTER //
// ./src/providers/log/log.ts